if (!customElements.get('pawloom-purchase-actions')) {
  customElements.define(
    'pawloom-purchase-actions',
    class PawloomPurchaseActions extends HTMLElement {
      connectedCallback() {
        this.acceleratedCheckout = this.querySelector('[data-pawloom-accelerated-checkout]');
        this.hasDownpay = this.dataset.hasDownpay === 'true';
        this.productInfo = this.closest('product-info');
        this.paymentTerms = this.productInfo?.querySelector('[data-pawloom-payment-terms]');
        this.eventScope = this.productInfo || document;

        if (!this.acceleratedCheckout || !this.hasDownpay) {
          this.setPurchaseState('full');
          return;
        }

        this.handleDownpayLoaded = this.handleDownpayLoaded.bind(this);
        this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
        this.handlePurchaseOptionChange = this.handlePurchaseOptionChange.bind(this);
        this.handleWindowLoad = this.handleWindowLoad.bind(this);

        this.eventScope.addEventListener('downpay:product:loaded', this.handleDownpayLoaded);
        this.eventScope.addEventListener('downpay:selling-plan:change', this.handleSellingPlanChange);
        this.eventScope.addEventListener('change', this.handlePurchaseOptionChange);

        this.syncFromCheckedOption();

        if (document.readyState === 'complete') {
          queueMicrotask(this.handleWindowLoad);
        } else {
          window.addEventListener('load', this.handleWindowLoad, { once: true });
        }
      }

      disconnectedCallback() {
        if (!this.hasDownpay || !this.eventScope) return;

        this.eventScope.removeEventListener('downpay:product:loaded', this.handleDownpayLoaded);
        this.eventScope.removeEventListener('downpay:selling-plan:change', this.handleSellingPlanChange);
        this.eventScope.removeEventListener('change', this.handlePurchaseOptionChange);
        window.removeEventListener('load', this.handleWindowLoad);
      }

      handleDownpayLoaded() {
        requestAnimationFrame(() => {
          if (this.isConnected) this.syncFromCheckedOption();
        });
      }

      handleWindowLoad() {
        this.syncFromCheckedOption();
      }

      handleSellingPlanChange(event) {
        if (!this.eventBelongsToProduct(event)) return;

        if (event.detail?.sellingPlanId) {
          this.setPurchaseState('deposit');
          return;
        }

        queueMicrotask(() => {
          if (this.isConnected) this.setPurchaseState('full');
        });
      }

      handlePurchaseOptionChange(event) {
        if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'purchase_option') return;
        if (!this.eventBelongsToProduct(event)) return;

        if (event.target.value === 'purchase_option_pay_deposit') {
          this.setPurchaseState('deposit');
        }
      }

      eventBelongsToProduct(event) {
        if (!this.productInfo) return true;
        return event.target instanceof Element && event.target.closest('product-info') === this.productInfo;
      }

      syncFromCheckedOption() {
        const checkedOption = this.eventScope.querySelector('input[name="purchase_option"]:checked');
        if (!checkedOption) return;

        this.setPurchaseState(checkedOption.value === 'purchase_option_pay_deposit' ? 'deposit' : 'full');
      }

      setPurchaseState(state) {
        this.dataset.purchaseState = state;

        if (this.acceleratedCheckout) {
          this.acceleratedCheckout.hidden = state !== 'full' && state !== 'deposit';
        }

        if (this.paymentTerms && this.hasDownpay) {
          const paymentTermsState = state === 'full' ? 'full' : state === 'deposit' ? 'deposit' : 'pending';

          this.paymentTerms.dataset.pawloomPaymentTermsState = paymentTermsState;
          this.paymentTerms.hidden = paymentTermsState === 'deposit';
          this.paymentTerms.toggleAttribute('inert', paymentTermsState !== 'full');

          if (paymentTermsState === 'full') {
            this.paymentTerms.removeAttribute('aria-hidden');
          } else {
            this.paymentTerms.setAttribute('aria-hidden', 'true');
          }
        }
      }
    }
  );
}
